import * as React from "react";
import { computed } from "mobx";
import { AppStore } from "../Stores/AppStore";

export interface ILinkProps {
	to: string;
	onClick?: React.EventHandler<React.MouseEvent<any>>;
	action?: Function;
	useHistoryOverride?: boolean;
	className?: string;
	testId?: string;
	testName?: string;
	title?: string;
	disabled?: boolean;
}

export class Link extends React.Component<ILinkProps, {}> {
	handleClick = (e: React.MouseEvent<any>) => {
		if (this.props.disabled) {
			return;
		}
		if (this.props.onClick) {
			this.props.onClick(e);
		}
		if (!e.defaultPrevented) {
			let path: string = null;
			if (this.props.useHistoryOverride) {
				let split = this.props.to.split("/");
				if (split.length > 1) {
					path = AppStore.getPath(split[1]);
				}
			}
			if (!path) {
				path = this.props.to;
			}

			AppStore.savePath(window.location.hash);
			AppStore.keepOnPage(path, true, this.props.action);
		}
	};
	@computed get getStyleClass(): string {
		let className = "";
		if (this.props.className) {
			className = this.props.className;
		}
		if (this.props.disabled) {
			className = ""; // we need style for it
		}
		return className;
	}
	render() {
		return (
			<a
				className={this.getStyleClass}
				onClick={this.handleClick}
				data-test-id={this.props.testId}
				data-test-name={this.props.testName}
				title={this.props.title ? this.props.title : this.props.title}
			>
				{this.props.children}
			</a>
		);
	}
}
